import React from 'react';

export function Spinner({ small }) {
  return <span className={`dp-spinner${small ? ' dp-spinner--sm' : ''}`} aria-hidden />;
}

export function Loader({ text = 'Loading…' }) {
  return (
    <div className="dp-loader" role="status">
      <Spinner />
      <span>{text}</span>
    </div>
  );
}

export function EmptyState({ title, body, action }) {
  return (
    <div className="dp-empty">
      <p className="dp-empty-title">{title}</p>
      {body ? <p className="dp-empty-body">{body}</p> : null}
      {action || null}
    </div>
  );
}

/** Inline message: tone = info | ok | warn | error */
export function Notice({ tone = 'info', children, action }) {
  if (!children) return null;
  return (
    <div className={`dp-notice dp-notice--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <div>{children}</div>
      {action || null}
    </div>
  );
}
